import React from 'react'
import { EmptyState } from '@components/ui'
import {
  DASHBOARD_SECTION_EMPTY_DESCRIPTION,
  DASHBOARD_SECTION_EMPTY_TITLE,
} from '@utils/dashboardSectionEmpty.util'
import './DashboardSectionEmptyState.style.css'

type DashboardSectionEmptyStateProps = {
  title?: string
  description?: string
  className?: string
}

function DashboardSectionEmptyState({
  title = DASHBOARD_SECTION_EMPTY_TITLE,
  description = DASHBOARD_SECTION_EMPTY_DESCRIPTION,
  className = '',
}: DashboardSectionEmptyStateProps): React.ReactElement {
  return (
    <EmptyState
      className={['dashboard-section-empty', className]
        .filter(Boolean)
        .join(' ')}
      iconClass="mgc mgc_chart_bar_fill"
      title={title}
      description={description}
    />
  )
}

export default DashboardSectionEmptyState
